import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";

export default function PaystackCheckout() {
  const { reference } = useParams();
  const [msg, setMsg] = useState("Opening Paystack secure checkout…");
  useEffect(() => {
    api.get(`/billing/checkout/${reference}`).then(({ data }) => {
      if (data.authorization_url && ["pending", "failed", "overdue"].includes(data.status)) window.location.href = data.authorization_url;
      else setMsg(data.status === "paid" ? "This invoice is already paid." : "This checkout link is no longer available. Use Pay on the billing page.");
    }).catch(() => setMsg("Checkout not found."));
  }, [reference]);
  return (
    <div className="mx-auto max-w-md pt-10 text-center fade-up" data-testid="paystack-redirect">
      <Lock className="mx-auto h-6 w-6 text-[#2B7F77]" />
      <p className="mt-3 text-sm text-slate-600" data-testid="paystack-redirect-message">{msg}</p>
      <Link to="/app/billing" className="mt-4 inline-block text-sm font-medium text-[#13294B] underline">Back to billing</Link>
    </div>
  );
}
